import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MAT_SNACK_BAR_DATA, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';
import { ToasterTypeEnum } from '../../enums/toasterType.enum';
import { CommonModule } from '@angular/common';
import { PipesModule } from '../../pipes/pipes.module';

@Component({
	selector: 'app-toasters',
	standalone: true,
	imports: [FormsModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule, CommonModule, PipesModule],
	templateUrl: './toasters.component.html',
	styleUrl: './toasters.component.scss'
})
export class ToastersComponent implements OnInit {
	iconType: string = '';
	color: string = '';
	constructor(
		@Inject(MAT_SNACK_BAR_DATA) public data: any,
		private snackBarRef: MatSnackBarRef<ToastersComponent>
	) { }
	ngOnInit(): void {
		this.iconType = this.typeOfToaster(this.data?.type);
	}

	closeSnackBar() {
		this.snackBarRef.dismiss();
	}

	typeOfToaster(toasterType: ToasterTypeEnum) {
		switch (toasterType) {
			case ToasterTypeEnum.SUCCESS:
				this.color = '#5fae4b';
				return 'check_rounded'
			case ToasterTypeEnum.ERROR:
				this.color = '#AF4B4B';
				return 'error_rounded'
			case ToasterTypeEnum.INFO:
				this.color = '#144686';
				return 'info'
			case ToasterTypeEnum.WARNING:
				this.color = '#AA8422';
				return 'warning_rounded'
		}
	}

}
